/**
 * @flow
 */

import React from 'react';
import { Select } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const options = [
    {
        value: 'CASH',
        text: (
            <FormattedMessage
                id="pages.appointments.details.invoice.InvoiceForm.cash"
                defaultMessage="Cash"
            />
        ),
    },
    {
        value: 'CC',
        text: (
            <FormattedMessage
                id="pages.appointments.details.invoice.InvoiceForm.credit_card"
                defaultMessage="Credit Card"
            />
        ),
    },
    {
        value: 'GIFT',
        text: (
            <FormattedMessage
                id="pages.appointments.details.invoice.InvoiceForm.gift_card"
                defaultMessage="Gift Card"
            />
        ),
    },
];

// This plain payment Select ignores the membership-related props that
// InvoiceFields passes uniformly to both payment variants. Strip them (along
// with redux-form's `meta`) so they don't leak onto the underlying DOM node.
const PaymentTypeField = ({
    meta,
    membership,
    allServices,
    setInfoVisible,
    fieldPath,
    change,
    invoice,
    ...props
}) => <Select options={options} {...props} />;

export default PaymentTypeField;
